module.exports = __webpack_public_path__ + "img/joyce-and-edgar-anderson.a5b891c6.png";